<template>
  <header class="header" :class="{ active: burgerActive }">
    <a class="logo" href="/">
      <img src="/img/faaren-logo.svg" />
    </a>

    <div class="burger" :class="{ active: burgerActive }" @click="burgerActive = !burgerActive">
      <span class="burger-line"></span> <span class="p-1">Menu</span>
    </div>

    <nav class="nav d-lg-flex align-items-center font-weight-bold" :class="{ active: burgerActive }">
      <a href="/katalog" target="_self" class="icon-navbar-color">
        <img src="../../../../img/car-sharp-regular.svg" class="icon-navbar-size icon pr-2" alt="car catalog icon navbar" style="fill: red !important;"/> Autos
      </a>

      <seperator-x class="w-100 d-block d-lg-none" />

      <a href="https://help.faaren.com/" target="_self" class="icon-navbar-color">
        <img src="../../../../img/question-regular.svg" class="icon-navbar-size pr-2" alt="car catalog icon navbar"/> FAQ & Hilfe
      </a>

      <seperator-x class="w-100 d-block d-lg-none"/>

      <a href="/login" target="_self" class="icon-navbar-color">
        <img src="../../../../img/user-sharp-regular.svg" class="icon-navbar-size pr-2" alt="car catalog icon navbar"/> Konto
      </a>

      <seperator-x class="w-100 d-block d-lg-none" />

      <contact-button :navbarModalPhoneNumber="navbarModalPhoneNumber"  class="w-100" />
    </nav>
  </header>
</template>
<script>

  export default {
    name: "NavBar",
    props: {
        navbarModalPhoneNumber: {
            default: false,
        }
    },
    data() {
      return {
        burgerActive: false,
      };
    },
  };
</script>
<style scoped lang="scss">
.header {
    border-bottom: unset !important;
    padding-top: 1rem;
    padding-bottom: 1rem;
}
.header .burger {
    padding: unset;
}
.bg-outside {
    width: 210px;
    height: 60px;
    cursor: pointer;
}
.icon-navbar-size {
    height: 21px;
}
.icon-navbar-color:hover {
    filter: brightness(0) saturate(100%) invert(23%) sepia(82%) saturate(2636%) hue-rotate(348deg) brightness(83%) contrast(86%);
}
</style>
